import _slicedToArray from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { __rest } from "tslib";
/* eslint-disable no-console */
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Tooltip/tooltip';
import { css } from '@patternfly/react-styles';
import { TooltipContent } from './TooltipContent';
import { TooltipArrow } from './TooltipArrow';
import { KeyTypes } from '../../helpers/constants';
import tooltipMaxWidth from '@patternfly/react-tokens/dist/esm/c_tooltip_MaxWidth';
import { Popper, getOpacityTransition } from '../../helpers/Popper/Popper';
export var TooltipPosition;
(function (TooltipPosition) {
  TooltipPosition["auto"] = "auto";
  TooltipPosition["top"] = "top";
  TooltipPosition["bottom"] = "bottom";
  TooltipPosition["left"] = "left";
  TooltipPosition["right"] = "right";
  TooltipPosition["topStart"] = "top-start";
  TooltipPosition["topEnd"] = "top-end";
  TooltipPosition["bottomStart"] = "bottom-start";
  TooltipPosition["bottomEnd"] = "bottom-end";
  TooltipPosition["leftStart"] = "left-start";
  TooltipPosition["leftEnd"] = "left-end";
  TooltipPosition["rightStart"] = "right-start";
  TooltipPosition["rightEnd"] = "right-end";
})(TooltipPosition || (TooltipPosition = {}));
// id for associating trigger with the content aria-describedby or aria-labelledby
var pfTooltipIdCounter = 1;
export var Tooltip = function Tooltip(_a) {
  var bodyContent = _a.content,
    _a$position = _a.position,
    position = _a$position === void 0 ? 'top' : _a$position,
    _a$trigger = _a.trigger,
    trigger = _a$trigger === void 0 ? 'mouseenter focus' : _a$trigger,
    _a$isVisible = _a.isVisible,
    isVisible = _a$isVisible === void 0 ? false : _a$isVisible,
    _a$isContentLeftAlign = _a.isContentLeftAligned,
    isContentLeftAligned = _a$isContentLeftAlign === void 0 ? false : _a$isContentLeftAlign,
    _a$enableFlip = _a.enableFlip,
    enableFlip = _a$enableFlip === void 0 ? true : _a$enableFlip,
    _a$className = _a.className,
    className = _a$className === void 0 ? '' : _a$className,
    _a$entryDelay = _a.entryDelay,
    entryDelay = _a$entryDelay === void 0 ? 300 : _a$entryDelay,
    _a$exitDelay = _a.exitDelay,
    exitDelay = _a$exitDelay === void 0 ? 300 : _a$exitDelay,
    _a$appendTo = _a.appendTo,
    appendTo = _a$appendTo === void 0 ? function () {
      return document.body;
    } : _a$appendTo,
    _a$zIndex = _a.zIndex,
    zIndex = _a$zIndex === void 0 ? 9999 : _a$zIndex,
    _a$maxWidth = _a.maxWidth,
    maxWidth = _a$maxWidth === void 0 ? tooltipMaxWidth.value : _a$maxWidth,
    _a$distance = _a.distance,
    distance = _a$distance === void 0 ? 15 : _a$distance,
    _a$aria = _a.aria,
    aria = _a$aria === void 0 ? 'describedby' : _a$aria,
    _a$flipBehavior = _a.flipBehavior,
    flipBehavior = _a$flipBehavior === void 0 ? ['top', 'right', 'bottom', 'left', 'top', 'right', 'bottom'] : _a$flipBehavior,
    _a$id = _a.id,
    id = _a$id === void 0 ? "pf-tooltip-".concat(pfTooltipIdCounter++) : _a$id,
    children = _a.children,
    _a$animationDuration = _a.animationDuration,
    animationDuration = _a$animationDuration === void 0 ? 300 : _a$animationDuration,
    reference = _a.reference,
    _a$ariaLive = _a['aria-live'],
    ariaLive = _a$ariaLive === void 0 ? reference ? 'polite' : 'off' : _a$ariaLive,
    boundary = _a.boundary,
    isAppLauncher = _a.isAppLauncher,
    tippyProps = _a.tippyProps,
    _a$removeFindDomNode = _a.removeFindDomNode,
    removeFindDomNode = _a$removeFindDomNode === void 0 ? false : _a$removeFindDomNode,
    _a$onTooltipHidden = _a.onTooltipHidden,
    onTooltipHidden = _a$onTooltipHidden === void 0 ? function () {} : _a$onTooltipHidden,
    rest = __rest(_a, ["content", "position", "trigger", "isVisible", "isContentLeftAligned", "enableFlip", "className", "entryDelay", "exitDelay", "appendTo", "zIndex", "maxWidth", "distance", "aria", "flipBehavior", "id", "children", "animationDuration", "reference", 'aria-live', "boundary", "isAppLauncher", "tippyProps", "removeFindDomNode", "onTooltipHidden"]);
  if (process.env.NODE_ENV !== 'production') {
    boundary !== undefined && console.warn('The Tooltip boundary prop has been deprecated. If you want to constrain the popper to a specific element use the appendTo prop instead.');
    isAppLauncher !== undefined && console.warn('The Tooltip isAppLauncher prop has been deprecated and is no longer used.');
    tippyProps !== undefined && console.warn('The Tooltip tippyProps prop has been deprecated and is no longer used.');
  }
  // could make this a prop in the future (true | false | 'toggle')
  var hideOnClick = true;
  var triggerOnMouseenter = trigger.includes('mouseenter');
  var triggerOnFocus = trigger.includes('focus');
  var triggerOnClick = trigger.includes('click');
  var triggerManually = trigger === 'manual';
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visible = _React$useState2[0],
    setVisible = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    opacity = _React$useState4[0],
    setOpacity = _React$useState4[1];
  var transitionTimerRef = React.useRef(null);
  var showTimerRef = React.useRef(null);
  var hideTimerRef = React.useRef(null);
  var prevExitDelayRef = React.useRef();
  var clearTimeouts = function clearTimeouts(timeoutRefs) {
    timeoutRefs.forEach(function (ref) {
      if (ref.current) {
        clearTimeout(ref.current);
      }
    });
  };
  // Cancel all timers on unmount
  React.useEffect(function () {
    return function () {
      clearTimeouts([transitionTimerRef, hideTimerRef, showTimerRef]);
    };
  }, []);
  var onDocumentKeyDown = function onDocumentKeyDown(event) {
    if (!triggerManually) {
      if (event.key === KeyTypes.Escape && visible) {
        hide();
      }
    }
  };
  var onTriggerEnter = function onTriggerEnter(event) {
    if (event.key === KeyTypes.Enter) {
      if (!visible) {
        show();
      } else {
        hide();
      }
    }
  };
  React.useEffect(function () {
    if (isVisible) {
      show();
    } else {
      hide();
    }
  }, [isVisible]);
  React.useEffect(function () {
    if (prevExitDelayRef.current < exitDelay) {
      clearTimeouts([transitionTimerRef, hideTimerRef]);
      hideTimerRef.current = setTimeout(function () {
        setOpacity(0);
        transitionTimerRef.current = setTimeout(function () {
          setVisible(false);
          onTooltipHidden();
        }, animationDuration);
      }, exitDelay);
    }
    prevExitDelayRef.current = exitDelay;
  }, [exitDelay]);
  var show = function show() {
    clearTimeouts([transitionTimerRef, hideTimerRef]);
    showTimerRef.current = setTimeout(function () {
      setVisible(true);
      setOpacity(1);
    }, entryDelay);
  };
  var hide = function hide() {
    clearTimeouts([showTimerRef]);
    hideTimerRef.current = setTimeout(function () {
      setOpacity(0);
      transitionTimerRef.current = setTimeout(function () {
        setVisible(false);
        onTooltipHidden();
      }, animationDuration);
    }, exitDelay);
  };
  var positionModifiers = {
    top: styles.modifiers.top,
    bottom: styles.modifiers.bottom,
    left: styles.modifiers.left,
    right: styles.modifiers.right,
    'top-start': styles.modifiers.topLeft,
    'top-end': styles.modifiers.topRight,
    'bottom-start': styles.modifiers.bottomLeft,
    'bottom-end': styles.modifiers.bottomRight,
    'left-start': styles.modifiers.leftTop,
    'left-end': styles.modifiers.leftBottom,
    'right-start': styles.modifiers.rightTop,
    'right-end': styles.modifiers.rightBottom
  };
  var hasCustomMaxWidth = maxWidth !== tooltipMaxWidth.value;
  var content = React.createElement("div", Object.assign({
    "aria-live": ariaLive,
    className: css(styles.tooltip, className),
    role: "tooltip",
    id: id,
    style: {
      maxWidth: hasCustomMaxWidth ? maxWidth : null,
      opacity: opacity,
      transition: getOpacityTransition(animationDuration)
    }
  }, rest), React.createElement(TooltipArrow, null), React.createElement(TooltipContent, {
    isLeftAligned: isContentLeftAligned
  }, bodyContent));
  var onDocumentClick = function onDocumentClick(event, triggerElement) {
    // event.currentTarget = document
    // event.target could be triggerElement or something else
    if (hideOnClick === true) {
      // hide on inside the toggle as well as on outside clicks
      if (visible) {
        hide();
      } else if (event.target === triggerElement) {
        show();
      }
    } else if (hideOnClick === 'toggle' && event.target === triggerElement) {
      // prevent outside clicks from hiding but allow it to still be toggled on toggle click
      if (visible) {
        hide();
      } else {
        show();
      }
    } else if (hideOnClick === false && !visible && event.target === triggerElement) {
      show();
    }
  };
  var addAriaToTrigger = function addAriaToTrigger() {
    if (aria === 'describedby' && children && children.props && !children.props['aria-describedby']) {
      return React.cloneElement(children, {
        'aria-describedby': id
      });
    } else if (aria === 'labelledby' && children.props && !children.props['aria-labelledby']) {
      return React.cloneElement(children, {
        'aria-labelledby': id
      });
    }
    return children;
  };
  return React.createElement(Popper, {
    trigger: aria !== 'none' && visible ? addAriaToTrigger() : children,
    reference: reference,
    popper: content,
    popperMatchesTriggerWidth: false,
    appendTo: appendTo,
    isVisible: visible,
    positionModifiers: positionModifiers,
    distance: distance,
    placement: position,
    onMouseEnter: triggerOnMouseenter && show,
    onMouseLeave: triggerOnMouseenter && hide,
    onPopperMouseEnter: triggerOnMouseenter && show,
    onPopperMouseLeave: triggerOnMouseenter && hide,
    onFocus: triggerOnFocus && show,
    onBlur: triggerOnFocus && hide,
    onDocumentClick: triggerOnClick && onDocumentClick,
    onDocumentKeyDown: triggerManually ? null : onDocumentKeyDown,
    onTriggerEnter: triggerManually ? null : onTriggerEnter,
    enableFlip: enableFlip,
    zIndex: zIndex,
    flipBehavior: flipBehavior,
    removeFindDomNode: removeFindDomNode
  });
};
Tooltip.displayName = 'Tooltip';